//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable global-require */
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import { latLng, icon, Icon } from 'leaflet'

// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  setup() {
    const zoom = 13
    const center = latLng(47.41322, -1.219482)
    const url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    const attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    const iconData = icon({
      iconUrl: require('@/assets/images/misc/leaf-green.png'),
      iconSize: [25, 50],
      iconAnchor: [16, 37],
    })

    const iconData2 = icon({
      iconUrl: require('@/assets/images/misc/leaf-red.png'),
      iconSize: [25, 50],
      iconAnchor: [16, 37],
    })

    return {
      zoom,
      center,
      url,
      attribution,
      iconData,
      iconData2,
    }
  },
}
/* eslint-disable global-require */
